import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import appScreenshot from "@/assets/app-adv3nture-screenshot.png.asset.json";

const VideoSection = () => {
  return (
    <section className="py-2 md:py-4">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-4"
        >
          <h2 className="text-3xl sm:text-4xl font-display font-bold mb-4">
            See <span className="text-gradient">AdV3nture</span> in action
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Explore the live app right here, no signup needed.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
          className="max-w-6xl mx-auto"
        >
          <a
            href="https://app.adv3nture.io"
            target="_blank"
            rel="noopener noreferrer"
            className="block glass rounded-2xl p-2 sm:p-3 overflow-hidden shadow-[0_0_60px_hsl(174_62%_47%/0.1)] hover:shadow-[0_0_80px_hsl(174_62%_47%/0.15)] transition-shadow duration-300"
          >
            <div className="flex items-center gap-1.5 px-3 py-2 border-b border-border/40">
              <span className="w-2.5 h-2.5 rounded-full bg-destructive/60" />
              <span className="w-2.5 h-2.5 rounded-full bg-secondary/60" />
              <span className="w-2.5 h-2.5 rounded-full bg-primary/60" />
              <span className="ml-3 text-xs text-muted-foreground font-mono truncate">
                app.adv3nture.io
              </span>
            </div>
            <div className="relative w-full rounded-b-xl overflow-hidden bg-muted/30">
              <img
                src={appScreenshot.url}
                alt="AdV3nture app interface showing investor discovery and founder profiles"
                loading="lazy"
                className="w-full h-auto block"
              />
            </div>
          </a>
          <div className="text-center mt-6">
            <Button asChild variant="outline" size="sm" className="gap-2">
              <a href="https://app.adv3nture.io" target="_blank" rel="noopener noreferrer">
                Open full app <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;
